import { render, staticRenderFns } from "./StepEight.vue?vue&type=template&id=596f4bf8&scoped=true&"
import script from "./StepEight.vue?vue&type=script&lang=js&"
export * from "./StepEight.vue?vue&type=script&lang=js&"
import style0 from "./StepEight.vue?vue&type=style&index=0&id=596f4bf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596f4bf8",
  null
  
)

export default component.exports